<template>
    <div class="nachweis-doppel-baeyer">
        <p>
            <b>Baeyer-Probe</b>
            <br />
            alkalische Kaliumpermanganatlösung (KMnO<sub>4</sub>) +
            ungesättigter Kohlenwasserstoff
            <br />
            rosa-violette Kaliumpermanganatlösung wird schnell braun
            <br />
            elektrophile Addition an die π-Elektronen der Doppelbindung
            <br />
            Produkt ist ein Diol, also zweiwertiger Alkohol. Aus Ethen entsteht
            so Glykol.
            <br />
            CH<sub>2</sub>=CH<sub>2</sub> + MnO<sub>4</sub><sup>-</sup> →
            CH<sub>2</sub>(OH)-CH<sub>2</sub>(OH) + MnO<sub>3</sub><sup>-</sup>
            <br />
            Permanganat ist ein sehr starkes Oxidationsmittel, das bei dieser
            Reaktion Braunstein bildet.
        </p>
    </div>
</template>

<script>
export default {
    name: 'nachweis-doppel-baeyer',
};
</script>
